import React, {useEffect, useRef, useState} from 'react';
import {Button, Form, FormGroup, Input, Label, Spinner} from 'reactstrap';
import {deleteField, doc, getDoc, increment, setDoc, updateDoc} from "firebase/firestore";
import {getDb} from 'util/Constants';
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import imageIcon from "../../assets/img/brand/image1.png"
import CropImage from "../reusable/cropImage"
import _ from "lodash";

import Papa from "papaparse";


export default function CompetenciesModal({isOpen, toggle, item, competencies, setCompetencies}) {
    const [data, setData] = useState({});
    const [logo, setLogo] = useState(null);
    const [imageError, setImageError] = useState(null);
    const [localImage, setLocalImage] = useState(null);
    const [uploadFiles, setUploadFiles] = useState(null);
    const [fileLink, setFileLink] = useState("");
    const fileInputRef = useRef(null);
    const [loader, setLoader] = useState(false);
    const [fileData, setFileData] = useState([]);

    useEffect(() => {

        setData(item);
        setLogo(item?.image)
    }, [item]);

    const handleSave = async (e) => {
        e.preventDefault();
        setLoader(true)
        const img = await addUrl();
        let _fileLink;
        // uploading file in storage
        const storage = getStorage();
        const fileRef = ref(storage, `${data.name + "-" + "competencies.csv"}`);
        // const result = await
        uploadBytes(fileRef, uploadFiles).then(result => {
            // const downloadUrl =
            getDownloadURL(result.ref).then(async (downloadUrl) => {
                console.log(downloadUrl);
                setFileLink(downloadUrl);
                let competenciesWithoutLevelCount = competencies.map(competency => {
                    const {levelCounts, ...rest} = competency;
                    return rest;
                });
                if (item?.hasOwnProperty('name')) {
                    const docRef = doc(getDb(), "Metadata_Games", "competencies");
                    const updatedTodos = competenciesWithoutLevelCount.map(e => {
                        if (e.name === item?.name) {
                            return {
                                ...e,
                                description: data?.description,
                                name: data?.name,
                                image: img,
                                fileLink: downloadUrl
                            };
                        }
                        return e;
                    });
                    const updatedTodos1 = competencies.map(e => {
                        if (e.name === item?.name) {
                            return {
                                ...e,
                                description: data?.description,
                                name: data?.name,
                                image: img,
                                fileLink: downloadUrl
                            };
                        }
                        return e;
                    });
                    await updateDoc(docRef, {
                        data: updatedTodos
                    });
                    setCompetencies(updatedTodos1)
                    if (fileData.length > 0) {
                        deleteQuestionsCount().then(() => {
                                uploadData()
                            }
                        )
                    } else {
                        setLoader(false)
                        toggle();
                    }
                } else {
                    const docRef = doc(getDb(), "Metadata_Games", "competencies");
                    await updateDoc(docRef, {
                        data: [...competenciesWithoutLevelCount, {...data, image: img, fileLink: downloadUrl}]
                    });
                    setCompetencies([...competencies, {...data, image: img, fileLink: downloadUrl}])
                    if (fileData.length > 0) {
                        deleteQuestionsCount().then(() => {
                                uploadData()
                            }
                        )
                    } else {
                        setLoader(false)
                        toggle();

                    }
                }
            });
        });
    };
    const handleChange = (e) => {
        const {name, value} = e.target;
        setData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const addUrl = async () => {
        if (typeof logo === "string" && !logo.includes("firebase")) {

            const _file = await urltoFile(logo, `${data.name + "-" + "competencies"}logo`, 'image/png');
            const storage = getStorage()
            const imageRef = ref(storage, `${data.name + "-" + "competencies"}logo`);
            const data1 = await uploadBytes(imageRef, _file);

            const downloadUrl = await getDownloadURL(data1.ref);
            return downloadUrl;
        } else {
            return logo;
        }
    };
    const urltoFile = (url, filename, mimeType) => {
        return (fetch(url)
                .then(function (res) {
                    return res.arrayBuffer();
                })
                .then(function (buf) {
                    return new File([buf], filename, {type: mimeType});
                })
        );
    }
    const deleteQuestionsCount = async () => {
        // Specify the document reference
        const docRef = doc(getDb(), 'MetaData_Questions_Count', 'analytics');
        // Get the document data
        try {
            const documentSnapshot = await getDoc(docRef);
            if (documentSnapshot.exists()) {
                const documentData = documentSnapshot.data();
                // Filter fields that start with a specific letter
                const fieldsToDelete = Object.keys(documentData).filter(field => field.startsWith(data.name));
                // Create an array of update operations
                const updateOperations = fieldsToDelete.map(field => ({
                    [field]: deleteField()
                }));

                // Delete fields using Promise.all
                await Promise.all(updateOperations.map(operation => updateDoc(docRef, operation)));


            } else {

            }
        } catch (error) {
            console.error('Error retrieving document data:', error);
        }
    }
    const uploadData = async () => {
        const countMap = {};
        try {
            for (const e of fileData) {
                if (e['Level'] && e['Level'] != "") {
                    const key = `${data.name}-${e["Level"]}-${_.startCase(e['Difficulty'])}-${e['Type']}`;
                    if (countMap[key]) {
                        ++countMap[key];
                    } else {
                        countMap[key] = 1;
                    }
                    const Ref = await setDoc(doc(getDb(), "Metadata_QuestionBank", key + "-" + countMap[key]), {
                        ID: `${data.name}-${e["Level"]}-${_.startCase(e['Difficulty'])}-${e['Type']}`,
                        ID2: `${data.name}-${_.startCase(e['Difficulty'])}-${e['Type']}`,
                        type: e['Type'],
                        name: e['Name'],
                        subject: e['Subject'],
                        email: e['Email'],
                        question: e['Question'],
                        ability: data.name,
                        'answerOne': e['Answer One'],
                        'responseOne': e['Response One'],
                        'answerTwo': e['Answer Two'],
                        'responseTwo': e['Response Two'],
                        'answerThree': e['Answer Three'],
                        'responseThree': e['Response Three'],
                        'answerFour': e['Answer Four'],
                        'responseFour': e['Response Four'],
                        'response': e['Response'],
                        'reward': e['Reward'],
                        difficulty: e['Difficulty'] ? _.startCase(e['Difficulty']) : "",
                        'count': countMap[key],
                        levelName: e["Level"]
                    });
                    const CountRef = doc(getDb(), "MetaData_Questions_Count", "analytics");
                    await updateDoc(CountRef, {
                        [`${data.name}-${e['Level']}-${_.startCase(e['Difficulty'])}-${e['Type']}`]: increment(1)
                    });
                }
            }
            setLoader(false);
            toggle();
        } catch (error) {
            console.error("Error adding document: ", error);
        }
    }
    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        setUploadFiles(file);
        // Reference the file and parse it
        Papa.parse(file, {
            header: true,
            complete: async function (results) {
                setFileData(results.data)
            },
        })

        fileInputRef.current.value = null; // Reset file input value

    };


    return (
        <Form onSubmit={handleSave}>
            <FormGroup>
                <Label for="competency">Competency</Label>
                <Input
                    type="text"
                    name="name"
                    disabled={item?.name}
                    required
                    value={data?.name}
                    onChange={handleChange}
                    placeholder="Competency"
                />
            </FormGroup>
            <FormGroup>
                <Label for="competency">Description</Label>
                <Input
                    type="text"
                    name="description"
                    required
                    value={data?.description || ''}
                    onChange={handleChange}
                    placeholder="description"
                />
            </FormGroup>
            <FormGroup>
                <div
                    className="  d-flex align-items-start justify-content-between">
                    <div>
                        <label className="textColor">Logo</label>
                        <div className="w-75 ">
                            {imageError === "left" &&
                                <p className="text-danger mb-0">Please Select image less than
                                    1mb</p>}
                            <span
                                className="text-secondary">(Image should be 340px x 60px or 17 : 3)</span>
                        </div>
                    </div>
                    <div style={{width: "59%", minHeight: "auto"}}
                         className="imageBg py-1 d-flex justify-content-center">
                        <label className="imageInput leftLogo"
                               role="button">
                            <img src={localImage ? localImage : logo ? logo : imageIcon}
                                 alt=""
                                 height={localImage ? 100 : logo ? 100 : 80}
                                 width={localImage ? 100 : logo ? 100 : 80}
                            />
                            {!logo &&
                                <span
                                    className={`ms-4 ${!logo && 'text-muted'}`}>{!logo && "Upload"}</span>
                            }
                            <CropImage aspectRatio={1} stateSetImage={setLogo} setError={setImageError}
                                       imageLocation="left"
                                       setLocal={setLocalImage}/>
                        </label>
                    </div>
                </div>
            </FormGroup>
            <FormGroup>

                <span>
                    <label htmlFor="imageUpload"

                           className={"btn btnColor custom-font  mb-0"}>
                        <i className="fa fa-upload mr-2"/>
                        {fileData.length === 0 ? "Upload File" : "File Selected"}
                    </label>
                    <input ref={fileInputRef}
                           onChange={handleFileUpload} className="d-none" id="imageUpload"
                           type="file"/>
                </span>
            </FormGroup>
            <Button disabled={loader} color="primary" type="submit">
                {loader ? (
                    <Spinner color="light" size="sm"/>
                ) : (
                    "Save"
                )}
            </Button>
            <Button color="secondary" onClick={toggle} disabled={loader}>
                Cancel
            </Button>
        </Form>

    );
}
